// What a table or a replay shows of its players beyond the record (design 14 §7): the avatar, and at ranked tables the
// rating and flair. Read once per set of players from the public GET /api/players; a seat not found (a bot) has none.

import { createEffect, createSignal, on } from "solid-js";
import { players as fetchPlayers } from "../api";
import type { PlayerInfo } from "../api";

export type PlayerInfos = Record<string, PlayerInfo>; // by record player id ("acct:<public id>")

export function createPlayerInfos(ids: () => string[]): () => PlayerInfos {
  const [infos, setInfos] = createSignal<PlayerInfos>({});
  const key = () =>
    ids()
      .filter((id) => id.startsWith("acct:"))
      .map((id) => id.slice(5))
      .sort()
      .join(",");
  createEffect(
    on(key, (k) => {
      if (!k) return setInfos({});
      fetchPlayers(k.split(",")).then(
        (r) => setInfos(Object.fromEntries(Object.entries(r).map(([id, v]) => [`acct:${id}`, v]))),
        () => {},
      );
    }),
  );
  return infos;
}

/** A bot's or an unknown seat's avatar: from its name, so it stays one across a game. */
export function avatarOfName(name: string, avatars: number): number {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % 65_521;
  return h % avatars;
}
